import React, { useEffect, useState } from "react";
import Header from "components/Header";
import KpiCard from "components/NewComponents/ProgressKPICard";
import TopRiskDistricts from "components/NewComponents/TopRiskDistricts";
import ReusableLineChart from "components/NewComponents/IndicatorsLineChart";
import EquityFocusCard from "components/NewComponents/EquityFocusCard";
import AlertsCard from "components/NewComponents/AlertsCard";
import DistrictBarComparison from "components/NewComponents/SecondHorizontalBarCard";
import DistrictSnapshotCard from "components/NewComponents/SnapshotCard";
const sampleData = [
    {
        rank: 1,
        district: "Nandurbar",
        category: "Tribal",
        score: 87,
        trend: +3,
        population: "4.2M",
        facilities: 54,

        // Key health indicators
        mmr: 68,
        nmr: 24,
        anc4: 61,
        inst: 76,
        lbw: 12,
    },
    {
        rank: 2,
        district: "Nashik",
        category: "Non-Tribal",
        score: 82,
        trend: -1,
        population: "3.1M",
        facilities: 41,

        mmr: 62,
        nmr: 21,
        anc4: 64,
        inst: 79,
        lbw: 9,
    },
    {
        rank: 3,
        district: "Mumbai",
        category: "Non-Tribal",
        score: 79,
        trend: 0,
        population: "5.4M",
        facilities: 62,

        mmr: 55,
        nmr: 18,
        anc4: 69,
        inst: 83,
        lbw: 11,
    },
];
const districtData = [
    { district: "Nandurbar", MMR: 65, NMR: 32, "ANC4+": 61, "Inst. Delivery": 79, LBW: 18 },
    { district: "Amravati", MMR: 53, NMR: 28, "ANC4+": 64, "Inst. Delivery": 76, LBW: 16 },
    { district: "Nagpur", MMR: 38, NMR: 22, "ANC4+": 69, "Inst. Delivery": 82, LBW: 17 },
    { district: "Pune", MMR: 27, NMR: 19, "ANC4+": 72, "Inst. Delivery": 88, LBW: 14 },
    { district: "Palghar", MMR: 21, NMR: 17, "ANC4+": 74, "Inst. Delivery": 87, LBW: 15 },
];

const equityData = {
    mainHeading: "Equity Focus - Rural / Urban / Tribal Gap",
    sections: [
        {
            subHeading: "ANC 4+ Coverage",
            categories: [
                { label: "Rural", value: 72, color: "#4F46E5", trend: +1 },
                { label: "Urban", value: 25, color: "#16A34A", trend: -1 },
                { label: "Tribal", value: 12, color: "#DC2626", trend: 0 },
                { label: "Non-Tribal", value: 15, color: "#DC2626", trend: 0 }
            ]
        },
        {
            subHeading: "Institutional Delivery",
            categories: [
                { label: "Rural", value: 68, color: "#4F46E5", trend: +2 },
                { label: "Urban", value: 22, color: "#16A34A", trend: -1 },
                { label: "Tribal", value: 10, color: "#DC2626", trend: 0 },
                { label: "Non-Tribal", value: 10, color: "#DC2626", trend: 0 }
            ]
        },
        {
            subHeading: "Full Immunization (12–23m)",
            categories: [
                { label: "Rural", value: 80, color: "#4F46E5", trend: +3 },
                { label: "Urban", value: 15, color: "#16A34A", trend: -2 },
                { label: "Tribal", value: 8, color: "#DC2626", trend: 0 },
                { label: "Non-Tribal", value: 12, color: "#DC2626", trend: +1 }
            ]
        }
    ]
};
const alertCategories = [
    { key: "maternal", label: "Maternal Health" },
    { key: "child", label: "Child Health" },
    { key: "infrastructure", label: "Infrastructure" },
];

const alerts = [
    {
        message: "Rising NMR over last 30 days in Gadchiroli, Nandurbar & Palghar.",
        severity: "high",
        category: "Clinical"
    },
    {
        message: "C-section rate > 35% in 7 high-load facilities across Pune & Nagpur.",
        severity: "medium",
        category: "Clinical"
    },
    {
        message: "ANC 4+ coverage below 65% in 11 tribal blocks.",
        severity: "medium",
        category: "Follow-up"
    },
    {
        message: "81 facilities have not reported any delivery in last 7 days.",
        severity: "low",
        category: "Logistics"
    }
];

function MotherChildHealthCareDashboard() {
    const [districtView, setDistrictView] = useState(null);
    const [seed, setSeed] = useState(0);
    // const [currentBirths, setCurrentBirths] = useState(DEFAULT_BIRTHS);
    const [stateGeoJSON, setStateGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // state polygon
            .then((res) => res.json())
            .then((data) => setStateGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);

    const [districtsGeoJSON, setdistrictsGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // <- all districts
            .then((res) => res.json())
            .then((data) => setdistrictsGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);
    const handleMenuClick = () => {
        // alert("Sidebar opened! (You can link this to real sidebar)");
    };

    const [searchQuery, setSearchQuery] = useState("");
    const [selected, setSelected] = useState("");
    return (
        <>
            <Header
                onMenuClick={handleMenuClick}
                selected={selected}
                setSelected={setSelected}
                onSearchChange={setSearchQuery}
                dashboardName="Mother & Child Care Dashboard"
            />

            <div className="container-fluid p-2">
                <div className="row g-3"> {/* g-3 = gap between cards */}
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-2">
                        <KpiCard
                            title="MATERNAL MORTALITY RATIO"
                            value="33"
                            unit="per 100k"
                            target="20"
                            statusText="Worsening"
                            statusType="worsening"
                            difference="-2"
                        />

                        <KpiCard
                            title="NEONATAL MORTALITY RATE"
                            value="11"
                            unit="per 1k"
                            target="7"
                            statusText="Stable"
                            statusType="stable"
                            difference="0"
                        />

                        <KpiCard
                            title="ANC 4+ COVERAGE"
                            value="95%"
                            target="100"
                            statusText="Improving"
                            statusType="improving"
                            difference="+3"
                        />
                        <KpiCard
                            title="INSTITUTIONAL DELIVIRES"
                            value="91%"
                            target="98"
                            statusText="Improving"
                            statusType="improving"
                            difference="+2"
                        />
                        <KpiCard
                            title="MATERNAL MORTALITY RATIO"
                            value="9%"
                            // unit="per 100k"
                            target="5"
                            statusText="Worsening"
                            statusType="worsening"
                            difference="-1"
                        />
                        <KpiCard
                            title="REPORTING COMPLETENESS (7D)"
                            value="92%"
                            target="95"
                            statusText="Improving"
                            statusType="improving"
                            difference="+4"
                        />
                    </div>
                    <div className="grid grid-cols-12 gap-2 w-full">

                        {/* COL 4 */}
                        <div className="col-span-12 md:col-span-4">
                            <TopRiskDistricts title="Top High-Risk Districts" data={sampleData} />

                            <div className="mt-3">
                                <DistrictSnapshotCard />
                            </div>

                        </div>

                        {/* COL 4 */}
                        <div className="col-span-12 md:col-span-4">
                            <ReusableLineChart
                                height={300}
                                labels={["Jan", "Feb", "Mar", "Apr", "May", "Jun"]}
                                datasets={[
                                    {
                                        label: "ANC4",
                                        data: [72, 75, 78, 79, 82, 85],
                                        color: "rgba(94, 114, 228, 1)",
                                    },
                                    {
                                        label: "NMR",
                                        data: [28, 27, 29, 26, 25, 24],
                                        color: "rgba(245, 54, 92, 1)",
                                    },
                                    {
                                        label: "MMR",
                                        data: [130, 128, 125, 123, 120, 118],
                                        color: "rgba(45, 206, 137, 1)",
                                    },
                                ]}
                            />
                            <div className="mt-2">
                                <DistrictBarComparison data={districtData} />
                            </div>


                        </div>

                        {/* COL 4 */}
                        <div className="col-span-12 md:col-span-4">
                            <EquityFocusCard
                                title={equityData.mainHeading}
                                sections={equityData.sections}
                            />
                            <div className="mt-2">
                                <AlertsCard
                                    title="Red Flags Today" alerts={alerts}
                                />
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </>
    );
}
export default MotherChildHealthCareDashboard;